import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "px-7 py-5" }
const _hoisted_8 = { class: "row mb-8" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_15 = { class: "row mb-12" }
const _hoisted_16 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = ["label"]
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "row mb-12" }
const _hoisted_21 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_22 = { class: "col-lg-8 fv-row" }
const _hoisted_23 = { class: "row mb-12" }
const _hoisted_24 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "col-lg-8 fv-row" }
const _hoisted_26 = { class: "row mb-6" }
const _hoisted_27 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_28 = { class: "col-lg-8 fv-row" }
const _hoisted_29 = { class: "row mb-6" }
const _hoisted_30 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_31 = { class: "col-lg-8 fv-row" }
const _hoisted_32 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_33 = { class: "row mb-6" }
const _hoisted_34 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_35 = { class: "col-lg-8 fv-row" }
const _hoisted_36 = { class: "row mb-6" }
const _hoisted_37 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_38 = { class: "col-lg-8 fv-row" }
const _hoisted_39 = { class: "row mb-6" }
const _hoisted_40 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_41 = { class: "col-lg-8 fv-row" }
const _hoisted_42 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_43 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_44 = { class: "badge badge-light-success fs-6" }
const _hoisted_45 = {
  key: 1,
  class: "d-flex justify-content-center py-10"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 2,
  class: "text-center py-10 text-muted fs-6"
}
const _hoisted_49 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  type: "button",
  class: "btn btn-light-success btn-sm me-2"
}
const _hoisted_52 = { class: "svg-icon svg-icon-2" }
const _hoisted_53 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_54 = { class: "indicator-label" }
const _hoisted_55 = { class: "indicator-progress" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_vue3_json_excel = _resolveComponent("vue3-json-excel")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'reports'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('registeredTradesPerQuarterReports')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _withModifiers(_ctx.onSubmitCreate, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control form-control-sm form-control-solid",
                          placeholder: _ctx.translate('From'),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.dateFrom) = $event))
                        }, null, 8, _hoisted_10), [
                          [_vModelText, _ctx.selectedItems.dateFrom]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control form-control-sm form-control-solid",
                          placeholder: _ctx.translate('To'),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItems.dateTo) = $event))
                        }, null, 8, _hoisted_12), [
                          [_vModelText, _ctx.selectedItems.dateTo]
                        ])
                      ])
                    ]),
                    _hoisted_13,
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.translate('selectPropertyGrouping')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedItems.propertyGroupingId) = $event)),
                          class: "form-select form-select-sm form-select-solid"
                        }, [
                          _createElementVNode("option", {
                            label: _ctx.translate('selectPropertyGrouping'),
                            disabled: "",
                            value: ""
                          }, null, 8, _hoisted_18),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyGroupings, (grouping) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: grouping.id,
                              value: grouping.id
                            }, _toDisplayString(grouping.titleAr), 9, _hoisted_19))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.selectedItems.propertyGroupingId]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("label", _hoisted_21, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.translate('Property Status')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedItems.selectedPropertyStatus,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedItems.selectedPropertyStatus) = $event)),
                          mode: "tags",
                          requierd: false,
                          label: "titleAr",
                          trackBy: "titleAr",
                          searchable: true,
                          canDeselect: true,
                          options: _ctx.registeredTradesDesc,
                          placeholder: _ctx.translate('selectPropertyStatus'),
                          valueProp: "id",
                          noResultsText: _ctx.translate('noResultsFound')
                        }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.translate('Government')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedItems.selectedGov,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedItems.selectedGov) = $event)),
                          mode: "tags",
                          requierd: false,
                          label: "titleAr",
                          trackBy: "titleAr",
                          searchable: true,
                          canDeselect: true,
                          options: _ctx.govs,
                          placeholder: _ctx.translate('selectGovernment'),
                          valueProp: "id",
                          noResultsText: _ctx.translate('noResultsFound')
                        }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("label", _hoisted_27, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.translate('selectAreas')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedItems.includedAreas,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedItems.includedAreas) = $event)),
                          mode: "tags",
                          requierd: false,
                          label: "titleAr",
                          trackBy: "titleAr",
                          searchable: true,
                          canDeselect: true,
                          options: _ctx.areas,
                          placeholder: _ctx.translate('selectAreas'),
                          valueProp: "id",
                          noResultsText: _ctx.translate('noResultsFound')
                        }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("label", _hoisted_30, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.translate('UnSelectAreas')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedItems.selectedArea,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedItems.selectedArea) = $event)),
                          mode: "tags",
                          requierd: false,
                          label: "titleAr",
                          trackBy: "titleAr",
                          searchable: true,
                          canDeselect: true,
                          options: _ctx.areas,
                          placeholder: _ctx.translate('selectAreas'),
                          valueProp: "id",
                          noResultsText: _ctx.translate('noResultsFound')
                        }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"]),
                        (
                      _ctx.selectedItems.includedAreas &&
                      _ctx.selectedItems.includedAreas.length > 0 &&
                      _ctx.selectedItems.selectedArea &&
                      _ctx.selectedItems.selectedArea.length > 0
                    )
                          ? (_openBlock(), _createElementBlock("small", _hoisted_32, _toDisplayString(_ctx.translate('areasIncludePrecedenceWarning')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("label", _hoisted_34, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.translate('UnSelectPropertyType')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedItems.selectedPropertyType,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedItems.selectedPropertyType) = $event)),
                          mode: "tags",
                          requierd: false,
                          label: "titleAr",
                          trackBy: "titleAr",
                          searchable: true,
                          canDeselect: true,
                          options: _ctx.propertyTypes,
                          placeholder: _ctx.translate('selectedPropertyType'),
                          valueProp: "id",
                          noResultsText: _ctx.translate('noResultsFound')
                        }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.translate('status')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedItems.status,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedItems.status) = $event)),
                          mode: "tags",
                          searchable: true,
                          canDeselect: true,
                          options: _ctx.statusOptions,
                          placeholder: _ctx.translate('selectStatus'),
                          valueProp: "value",
                          label: "label",
                          trackBy: "label",
                          noResultsText: _ctx.translate('noResultsFound')
                        }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("label", _hoisted_40, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('statusNotes')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedItems.statusNotesIds,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedItems.statusNotesIds) = $event)),
                        mode: "tags",
                        searchable: true,
                        canDeselect: true,
                        options: _ctx.statusNotesOptions,
                        placeholder: _ctx.translate('selectStatusNotes'),
                        valueProp: "value",
                        label: "label",
                        trackBy: "label",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ])
                  ]),
                  (_ctx.showExportBtn && _ctx.data && _ctx.data.data && _ctx.data.data.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.translate('NumOfRegisteredTrades')) + ": " + _toDisplayString(_ctx.data.data.length), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                    : _createCommentVNode("", true),
                  (_ctx.hasQueried && !_ctx.isLoading && (!_ctx.data || !_ctx.data.data || _ctx.data.data.length === 0))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.translate('noDataFound')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                (_ctx.showExportBtn && _ctx.data && _ctx.data.data && _ctx.data.data.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                      _createVNode(_component_vue3_json_excel, {
                        "json-data": _ctx.data.data,
                        fields: _ctx.excelHeader,
                        header: _ctx.excelHeaderRows,
                        worksheet: "Registered Trades Per Quarter WorkSheet",
                        name: 
                'Registered_Trades_Per_Quarter_' +
                'Reports_' +
                new Date().toISOString().slice(0, 10) +
                '.xls'
              
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", _hoisted_51, [
                            _createElementVNode("span", _hoisted_52, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil009.svg" })
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.translate('export')), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["json-data", "fields", "header", "name"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light-danger btn-sm me-3",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
                }, _toDisplayString(_ctx.translate('resetFilters')), 1),
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('back')), 1),
                _createElementVNode("button", _hoisted_53, [
                  _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.translate('query')), 1),
                  _createElementVNode("span", _hoisted_55, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_56
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ])
      ]))
    : _createCommentVNode("", true)
}